import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, TextField, Typography } from '@material-ui/core';

// COMPONENTS
import RadioCard from '@/components/Form/RadioCard';
import CheckBoxCard from '@/components/Form/CheckBoxCard';

// STYLES
import { TitleContainer, Title } from './styles';

const Question = props => {
  const {
    data,
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    onRadioCardChange,
    onCheckboxChange,
    isRequired,
  } = props;

  const handleRadioChange = event => {
    onRadioCardChange(event, handleChange);
  };

  const handleCheckboxChange = event => {
    onCheckboxChange(event, handleChange);
  };

  const gridAnswersMd = useMemo(() => {
    const length = data.answers?.length;

    if (length % 4 === 1 || length % 3 === 0) {
      return 4;
    }

    return 3;
  }, [data.answers?.length]);

  return (
    <>
      <TitleContainer className="form-title">
        {data.question && (
          <Title
            className={clsx(isRequired && 'required')}
            variant="h4"
            align="center"
            component="h1"
          >
            {data.question}
          </Title>
        )}
        {data.subtitle && (
          <Typography variant="subtitle1" align="center">
            {data.subtitle}
          </Typography>
        )}
      </TitleContainer>
      <Grid container spacing={1} justifyContent="center">
        {data.type === 'radio' &&
          data.answers.map(item => (
            <Grid item xs={6} sm={4} md={gridAnswersMd} key={item.value}>
              <RadioCard
                name={data.slug}
                text={item.text}
                handleChange={handleRadioChange}
                handleBlur={handleBlur}
                value={item.value}
                checkedValue={values[data.slug]}
              />
            </Grid>
          ))}
        {data.type === 'checkbox' &&
          data.answers.map(item => (
            <Grid item xs={6} sm={4} md={gridAnswersMd} key={item.value}>
              <CheckBoxCard
                name={data.slug}
                value={item.value}
                text={item.text}
                handleChange={handleCheckboxChange}
                handleBlur={handleBlur}
                checkedValue={values[data.slug]}
              />
            </Grid>
          ))}
        {data.type === 'text' && (
          <Grid item xs={12}>
            <TextField
              name={data.slug}
              value={values[data.slug]}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched[data.slug] && !!errors[data.slug]}
              helperText={touched[data.slug] && errors[data.slug]}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

Question.defaultPros = {
  isRequired: false,
};

Question.propTypes = {
  data: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  onRadioCardChange: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
};

export default React.memo(Question);
